import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

function getSDM20LHTs() {
    return dispatch => {
        return apiCaller
            .call(api.getAllSDM20LHTs())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_SDM20LHTS',
                        SDM20LHTs: data.SDM20LHTs
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHESDM20LHTs - ', error);
                throw error;
            });
    };
}
function getSDM20LHTDetails(SDM20LHTId) {
    return dispatch => {
        return apiCaller
            .call(api.getSDM20LHTDetails(SDM20LHTId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_SDM20LHT_DETAILS',
                        SDM20LHTId: data.SDM20LHTDetails.macAddress,
                        SDM20LHTDetails: data.SDM20LHTDetails
                    });
                }

                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHESDM20LHTDetails - ', error);
                throw error;
            });
    };
}
function refreshSDM20LHTStatus(SDM20LHTMac) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductCheckStatus('SDM20LHT', SDM20LHTMac)
            .catch(error => {
                Logger.log('dataActions: refreshMyFHESDM20LHTStatus - ', error);
                throw error;
            });
    };
}
function dissociateSDM20LHTUser(SDM20LHTMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUser('SDM20LHT', SDM20LHTMac, userId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM20LHTUser - ', error);
                throw error;
            });
    };
}
function dissociateSDM20LHTUserAndSwitchMaster(SDM20LHTMac, userId, masterId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUserAndSwitchMaster('SDM20LHT', SDM20LHTMac, userId, masterId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM20LHTUserAndSwitchMaster - ', error);
                throw error;
            });
    };
}
function switchSDM20LHTMaster(SDM20LHTMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductMasterSwitch('SDM20LHT', SDM20LHTMac, userId)
            .catch(error => {
                Logger.log('dataActions: switchMyFHESDM20LHTMaster - ', error);
                throw error;
            });
    };
}

export {
    getSDM20LHTs,
    getSDM20LHTDetails,
    refreshSDM20LHTStatus,
    dissociateSDM20LHTUser,
    dissociateSDM20LHTUserAndSwitchMaster,
    switchSDM20LHTMaster
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM20LHT/actions.js